import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck, AlertTriangle, Info } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_META = {
  no_policy:               { color: 'border-orange/40 bg-orange/5 text-navy',     icon: AlertTriangle },
  within_quick_quotation:  { color: 'border-green-300 bg-green-50 text-green-800', icon: ShieldCheck },
  within_authority:        { color: 'border-green-300 bg-green-50 text-green-800', icon: ShieldCheck },
  tender_required:         { color: 'border-orange/50 bg-orange/10 text-navy',     icon: Info },
};

export default function PolicyComplianceBadge({ tenderId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/tenders/${tenderId}/compliance`, { withCredentials: true })
      .then(({ data }) => { if (mounted) setData(data); })
      .catch(() => {});
    return () => { mounted = false; };
  }, [tenderId]);

  if (!data) return null;
  const meta = STATUS_META[data.compliance?.status] || STATUS_META.no_policy;
  const Icon = meta.icon;

  return (
    <div className={`p-3 rounded-lg border-2 ${meta.color} mb-4`} data-testid="policy-compliance-badge">
      <div className="flex items-start gap-2">
        <Icon className="h-4 w-4 mt-0.5 flex-shrink-0" />
        <div className="text-xs sm:text-sm">
          <div className="font-bold">{data.compliance?.label}</div>
          <div className="opacity-80">
            {data.policy_version
              ? `Governed by Procurement Policy v${data.policy_version} · Resolution ${data.resolution_number || '—'}${data.effective_date ? ` · Effective ${new Date(data.effective_date).toLocaleDateString()}` : ''}`
              : 'No active Procurement Policy linked to this tender.'}
          </div>
        </div>
      </div>
    </div>
  );
}
